module.exports = __webpack_public_path__ + "img/logo-header.642421cc.png";